<template>
  <div>
    <vs-card>
      <template #header>
        <h3>Uygulama Erişim Ekranı</h3>
      </template>

      <vs-tabs alignment="center">
        <vs-tab
            v-for="(item, i) in tabs"
            :key="i"
            :label="item.name"
        >
          <div>
            <component :is="item.component"></component>
          </div>
        </vs-tab>
      </vs-tabs>

    </vs-card>
  </div>
</template>

<script>
  import Traffic from "./Traffic";
  import BrowserStats from "./BrowserStats";
  import TopPages from "./TopPages";
  import Queries from "./Queries";
  import TopQueries from "./TopQueries";
  import TopCountries from "./TopCountries";
  import TopOs from "./TopOs";

  export default {
    name: "analytics-index",
    title: "Analitik",

    components: {
      Traffic,
      BrowserStats,
      TopPages,
      Queries,
      TopQueries,
      TopCountries,
      TopOs,
    },

    data() {
      return {
        tabs: [
          { name: 'Erişim', component: 'Traffic'},
          { name: 'Web Tarayıcısı İstatistikleri', component: 'BrowserStats'},
          { name: 'En Çok Ziyaret Edilen Sayfalar', component: 'TopPages'},
          { name: 'İşletim Sistemleri', component: 'TopOs'},
          { name: 'Sorgular', component: 'Queries'},
          { name: 'En Çok Yapılan Sorgular', component: 'TopQueries'},
        ]
      }
    }
  }
</script>

<style scoped>
.vs-pagination--li.is-current .effect{
      background-color: #E6272D !important;
      border-radius:25px;
  }
</style>